import { AitRowGroupData } from "aic";
import { rowPreProcess } from "./rowPreProcess";

/**
 * Preprocess body row groups, ensuring each row and row group is compliant and has aitid.
 *
 * @param defaultCellWidth - Default width to apply to cells
 * @param blank - Blank value to use for new empty cells
 * @param columnIds - Optional array of column IDs to assign to cells
 * @param rgs - Optional row groups to process
 * @returns Processed row groups
 */
export const bodyPreProcess = <T>(
  defaultCellWidth: number,
  blank: T,
  columnIds: string[],
  rgs?: AitRowGroupData<T>[],
): AitRowGroupData<T>[] => {
  return (rgs ?? []).map((rg) => {
    return {
      ...rg,
      rows: rowPreProcess(defaultCellWidth, blank, columnIds, rg.rows),
      aitid: rg.aitid ?? crypto.randomUUID(),
    };
  });
};
